import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';

import { GET_PAGINATED_USERS } from './useGetPaginatedUsers.graphql';
import {
  IGetPaginatedUsersQueryGraphQLResponse,
  IGetPaginatedUsersQueryVariables,
  IHandleGetPaginatedUsersParams,
  IUseGetPaginatedUsers,
  IUseGetPaginatedUsersOptions,
} from './useGetPaginatedUsers.interfaces';

const useGetPaginatedUsers = (options?: IUseGetPaginatedUsersOptions): IUseGetPaginatedUsers => {
  const { fetchPolicy, onCompleted, onError, query, tokens } = options ?? ({} as IUseGetPaginatedUsersOptions);

  const [executeGetPaginatedUsers, { loading: isLoading }] = useLoggedGeladaLazyQuery<
    IGetPaginatedUsersQueryGraphQLResponse,
    IGetPaginatedUsersQueryVariables
  >({
    options: {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        if (!data?.group?.getUsersPaginated) {
          console.error('Unexpected response structure:', data);
          return;
        }
        
        const { getUsersPaginated } = data.group;

        onCompleted({
          connection: getUsersPaginated
        });
      },
      onError,
    },
    query: query ?? GET_PAGINATED_USERS,
    tokens,
  });


  const handleGetPaginatedUsers = async ({
    groupId,
    userTypeId,
  }: IHandleGetPaginatedUsersParams) => {
    await executeGetPaginatedUsers({
      variables: {
        groupId,
        userTypeId
      },
    });
  };

  return {
    handleGetPaginatedUsers,
    isLoading,
  };
};

export { useGetPaginatedUsers };
